module.exports = __webpack_public_path__ + "img/授予奖项.6fbcc56a.png";